import React, { useEffect, useState } from "react";
import NumberPill from "../NumberPill";
import { useDispatch } from "react-redux";
import { updateFiguritas } from "../../actions/figuritasActions";
import { updateEstadoFigurita } from "../../utils/figuritas.js";
import { useSelector } from "react-redux";
import Accordion from "../Accordion/Accordion";
import { updateAlbumCollection } from "../../firebase/firestore";
import { albumKeysSorted } from "../../utils/figuritas.js";

export default function AlbumAccordion({
  figuritasSorted,
  accordion,
  hideCount,
  updating,
  update,
}) {
  const [timeout, setTimeOut] = useState(null);
  const dispatch = useDispatch();
  const album = useSelector((state) => state.figuritasReducer.figuritas);
  const currentUser = useSelector((state) => state.currentUser.user);

  const updateFigurita = (figurita, seccion) => {
    const autorizado = album.autorizados.find(
      (autorizado) =>
        autorizado.email === currentUser.email && autorizado.editar
    );
    if (autorizado || album.owner.uid === currentUser.uid) {
      const updateMethod = updateEstadoFigurita[accordion];

      dispatch(updateFiguritas(updateMethod(figurita, album, seccion)));
      handleUpdate();
    }
  };

  function handleUpdate() {
    clearTimeout(timeout);
    updating(true);
    setTimeOut(
      setTimeout(() => {
        updating(false);
      }, 3000)
    );
  }

  useEffect(() => {
    if (!update && update !== null) {
      updateAlbumCollection(album.owner, album);
    }
    if (update && currentUser) {
      const handleTabClose = (event) => {
        event.preventDefault();

        return (event.returnValue = "Are you sure you want to exit?");
      };

      window.addEventListener("beforeunload", handleTabClose);

      return () => {
        window.removeEventListener("beforeunload", handleTabClose);
      };
    }
  }, [update]);

  return (
    <>
      {album &&
        albumKeysSorted(figuritasSorted).map((key, index) => {
          const counterText = hideCount
            ? ""
            : figuritasSorted[key].length + " / ";
          return (
            <Accordion
              key={"section" + index}
              title={
                <>
                  <span>{key.toUpperCase()}</span>
                  {accordion === "album" ? (
                    <em>{album.album[key].length + " figuritas"}</em>
                  ) : (
                    <em>{counterText + album.album[key].length}</em>
                  )}
                </>
              }
            >
              <div className="numbersContainer">
                {figuritasSorted[key].length > 0 &&
                  figuritasSorted[key].map((figurita) => {
                    return (
                      <NumberPill
                        key={figurita.numero}
                        number={figurita.numero.toString()}
                        estado={figurita.estado}
                        onClick={() =>
                          updateFigurita(figurita, key, "section" + index)
                        }
                      />
                    );
                  })}
                {figuritasSorted[key].length === 0 ? (
                  accordion === "nola" ? (
                    <p>Ya las tenés todas!</p>
                  ) : accordion === "repe" ? (
                    <p>Todavía no tenés ninguna repetida.</p>
                  ) : (
                    <p>Todavía no tenés ninguna.</p>
                  )
                ) : (
                  ""
                )}
              </div>
            </Accordion>
          );
        })}
    </>
  );
}
